import { Typography } from "@mui/material"
import type { BiomeshSensorResponse } from "@phc/common/gen/threatAnalyticsGen"
import {
  getListSensorsBiomeshSensorListGetQueryKey,
  useDeleteSensorBiomeshSensorSensorIdDelete,
} from "@phc/common/gen/threatAnalyticsGen"
import { useQueryClient } from "@tanstack/react-query"
import { enqueueSnackbar } from "notistack"
import type { FC } from "react"
import { useCallback } from "react"
import { Modal } from "../Shared/Modal"
import { extractApiError } from "./copUtils"

interface DeleteSensorDialogProps {
  open: boolean
  onClose: () => void
  sensor: BiomeshSensorResponse
}

export const DeleteSensorDialog: FC<DeleteSensorDialogProps> = ({
  open,
  onClose,
  sensor,
}) => {
  const queryClient = useQueryClient()
  const { mutateAsync: deleteSensor, isPending } =
    useDeleteSensorBiomeshSensorSensorIdDelete()

  const handleConfirm = useCallback(async () => {
    try {
      await deleteSensor({ sensorId: sensor.sensor_id })
      await queryClient.invalidateQueries({
        queryKey: getListSensorsBiomeshSensorListGetQueryKey(),
      })
      enqueueSnackbar("Sensor deleted", { variant: "success" })
      onClose()
    } catch (err) {
      enqueueSnackbar(extractApiError(err, "Failed to delete sensor"), {
        variant: "error",
      })
    }
  }, [deleteSensor, sensor.sensor_id, queryClient, onClose])

  return (
    <Modal
      open={open}
      onClose={onClose}
      onConfirm={() => void handleConfirm()}
      title="Delete Sensor"
      confirmLabel="Delete"
      disableBtns={isPending}
    >
      <Typography sx={{ mt: 1 }}>
        Are you sure you want to delete <strong>{sensor.sensor_name}</strong>?
      </Typography>
    </Modal>
  )
}
